import * as React from "react"

import { cn } from "@commenda/utils"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-chat-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-chat-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-chat-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
